<template>
  <div class="mod-config">
    <div style="border-radius: 30px">
      <el-form
        :inline="true"
        size="mini"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row>
          <el-form-item label="子公司" prop="subcompanyId">
            <el-select  v-model="subcompanyId" @change="getSupCompanyList" style="width: 100%">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商代码" prop="venderCode">
            <el-input
              clearable
              size="mini"
              v-model="venderCode"
              style="width: 150px"
              placeholder="供应商代码"
              @blur="getDataList"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商名称" prop="venderName">
            <el-input
              clearable
              size="mini"
              v-model="venderName"
              style="width: 150px"
              placeholder="供应商名称"
              @blur="getDataList"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="invitedStatus" label-width="45px">
            <!-- <el-checkbox v-model="checkCreated" label="已创建" size="mini" @change="handleCheckAllChange" style="margin-right: 10px;"></el-checkbox>
                        <el-checkbox v-model="checkInvited" label="已邀请" size="mini" @change="handleCheckAllChange" style="margin-right: 10px;"></el-checkbox>
                        <el-checkbox v-model="checkInvitedRecall" label="已撤回" size="mini" @change="handleCheckAllChange" style="margin-right: 10px;"></el-checkbox> -->
            <el-select v-model="invitedStatus" clearable placeholder="请选择">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button
              size="mini"
              @click="queryHandle()"
              icon="el-icon-search"
              style="margin-left: 10px"
              >查询
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="createData()"
              icon="el-icon-plus"
              >新建</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="updateByCheckInvited()"
              :disabled="dataListSelections.length <= 0"
              :loading="invitedLoading"
              >发起邀请
            </el-button>
            <el-button
              type="success"
              size="mini"
              @click="updateByRevert()"
              :disabled="dataListSelections.length <= 0"
              >发起撤回
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div v-loading="dataListLoading">
      <el-table
        :data="dataList"
        size="mini"
        :row-class-name="rowClassName"
        :height="style.gridStyle.height"
        @selection-change="selectionChangeHandle"
        :header-cell-style="{ background: '#f5f5f5' }"
        border
      >
        <el-table-column
          align="center"
          v-model="something"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          label="序号"
          align="center"
          width="55"
        >
          <template slot-scope="scope">
            {{ scope.row.rowid }}
          </template>
        </el-table-column>
        <el-table-column
          prop="venderStatus"
          header-align="center"
          align="center"
          label="状态"
          min-width="80"
        >
          <template slot-scope="scope">
            <span style="color: #409eff" v-if="scope.row.venderStatus == '0'"
              >已创建</span
            >
            <span style="color: #67c23a" v-if="scope.row.venderStatus == '1'"
              >已邀请</span
            >
            <span style="color: #e6a23c" v-if="scope.row.venderStatus == '2'"
              >已撤回</span
            >
            <span style="color: #909399" v-if="scope.row.venderStatus == '3'"
              >已完善</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="venderName"
          header-align="center"
          align="left"
          label="供应商名称"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="venderUserDetail(scope.row)">
              {{ scope.row.venderName }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="venderLogin"
          header-align="center"
          align="left"
          label="供应商账号"
          min-width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.venderLogin }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateName"
          header-align="center"
          align="right"
          label="更新人"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.updateName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateTimeStr"
          header-align="center"
          align="right"
          label="更新日期"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTimeStr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createdName"
          header-align="center"
          align="right"
          label="创建人"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.createdName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTimeStr"
          header-align="center"
          align="right"
          label="创建日期"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.createTimeStr }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="150px"
        >
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              v-show="!(row.dataSource === 'OA') && row.venderStatus !== '1'"
              @click="updateHandle(row)"
              icon="el-icon-edit"
              >修改</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deleteHandle(row)"
              class="button-danger"
              icon="el-icon-delete"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <!-- 弹窗 供应商 查看 / 新增 / 修改 -->
    <el-dialog
      title="供应商信息"
      width="60%"
      :visible.sync="dialogVisible"
      :rules="dataRule"
      @close="closeDialog"
    >
      <div style="margin-top: 30px">
        <el-form
          :model="temp"
          label-width="120px"
          :rules="dataRule"
          size="mini"
          ref="temp"
          style="margin-top: 5px"
        >
          <el-row :gutter="80">
            <el-col :span="11">
              <el-button
                size="mini"
                v-if="!editflag"
                type="primary"
                @click="selectAdmitSupplier()"
                icon="el-icon-search"
                style="margin-left: 10px"
                >从供应商中选择</el-button
              >
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-tooltip placement="top" content="" effect="light">
                <div slot="content">{{ temp.venderName }}</div>
                <el-form-item label="供应商名称：" prop="venderName">
                  <el-input
                    :disabled="!showEditButton || selectFromOA"
                    v-model="temp.venderName"
                  />
                </el-form-item>
              </el-tooltip>
            </el-col>
            <el-col :span="11">
              <el-tooltip placement="top" content="" effect="light">
                <div slot="content">{{ temp.venderAdd }}</div>
                <el-form-item label="供应商地址：" prop="venderAdd">
                  <el-input
                    :disabled="!showEditButton || selectFromOA"
                    v-model="temp.venderAdd"
                  />
                </el-form-item>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="联系人：" prop="venderContacts">
                <el-input
                  :disabled="!showEditButton || selectFromOA"
                  v-model="temp.venderContacts"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="电话：" prop="venderTel">
                <el-input
                  :disabled="!showEditButton || selectFromOA"
                  v-model="temp.venderTel"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="11">
              <el-form-item label="邮箱：" prop="venderMail">
                <el-input
                  :disabled="!showEditButton || selectFromOA"
                  v-model="temp.venderMail"
                />
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="子公司：" prop="supcompanyCode">
                <el-select :disabled="!showEditButton || selectFromOA"  v-model="temp.supcompanyCode" @change="getSupCompanyList" style="width: 100%">
                  <el-option
                  v-for="item in supCompanyList"
                  :key="item.orgCode"
                  :label="item.orgName"
                  :value="item.orgCode"
                  >
                  </el-option> 
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row :gutter="80">
            <el-col :span="11">
              <div slot="content">{{ temp.isPru }}</div>
              <el-form-item label="生产供应商" prop="isPru">
                <el-checkbox
                  v-model="temp.isPru"
                  :true-label="1"
                  :false-label="0"
                  :disabled="selectFromOA"
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <div slot="content" >{{ temp.isGen }}</div>
              <el-form-item  label="非生产供应商" prop="isGen">
                <el-checkbox
                  v-model="temp.isGen"
                  :true-label="1"
                  :false-label="0"
                  :disabled="selectFromOA"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="80">
            <el-col :span="11">
              <el-button
                size="mini"
                v-if="!editflag"
                type="primary"
                @click="selectMtlClass()"
                icon="el-icon-search"
                style="margin-left: 10px"
                >选择供应商物料分类</el-button
              >
            </el-col>
            <el-col :span="50" style="margin-left: -250px">
              <div v-if="displayNames.length > 0">
                <ul class="no-bullet">
                  <li v-for="name in displayNames" :key="name">
                    {{ name.materialGroupCode }} {{ name.materialGroupName }}
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
          <div style="color: red"> 供应商物料分类：<span>{{mtlClass}}</span></div>
        </el-form>
      </div>
      <span slot="footer">
        <el-button
          type="primary"
          @click="dataFormSubmit()"
          :loading="submitLoading"
          size="mini"
          v-if="showEditButton"
          >保 存</el-button
        >
        <el-button @click="dialogVisible = false" size="mini" v-if="!editflag"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="当前处理含发送邮件，请耐心等待！"
      :modal="true"
      :center="true"
      :visible.sync="invitedLoading"
      :modal-append-to-body="false"
      :append-to-body="false"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
    </el-dialog>

    <!-- 子组件 -->
    <supplier-admit
      v-if="supplierAdmitInquiryVisible"
      @supplierAdmitRow="handleReceivedRowData"
      ref="supplierAdmit"
      @closeDialog="closeDialog()"
      @refreshDataList="getDataList"
    ></supplier-admit>
    <supplier-mtl
      v-if="supplierMtlVisible"
      ref="supplierMtl"
      @refreshDataList="getDataList"
      @materialGroupNames="getMaterialGroupNames"
    ></supplier-mtl>
  </div>
</template>
<script>
import {
  listSupplierInvite,
  createSupplier,
  updateSupplier,
  inviteSupplier,
  inviteRecall,
  deleteInviteSupplier,
  saveToMtl,
  createUse
} from "@/controller/supplier";
import SupplierAdmit from "./supplier-admit-inquiry.vue";
import SupplierMtl from "./supplier-mtl.vue";
import {supCompanyList} from "@/controller/sys";
import {getMaterialGroup} from "../../../../controller/portal";

export default {
  name: "SupplierInviteIndex",
  components: {
    SupplierAdmit,
    SupplierMtl,
  },

  data() {
    return {
      subcompanyId:'',
      submitLoading: false,
      supplierId: "",
      mtlData: [],
      selectFromOA: false,
      supplierAdmitInquiryVisible: false,
      supplierMtlVisible: false,
      selectMtl: false,
      invitedLoading: false,
      invitedStatus: "",
      displayNames: [],
      dialogVisible: false,
      supCompanyList: [],
      dataForm: {
        key: "",
      },
      flag: "",
      gpsStatusvalflag: "",
      radio: "",
      radioSelect: "", //选中的数据赋值给它
      temp: {
        venderinviteId: "",
        venderName: "",
        venderAdd: "",
        venderContacts: "",
        venderTel: "",
        venderMail: "",
        isPruChecked: "",
        dataSource: "",
        isPru: "",
        isGen: "",
        supcompanyCode: ""
        
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showUsers: false,
      venderId: "",
      venderinviteId: "",
      venderName: "",
      venderCode: "",
      checkCreated: true,
      checkInvited: true,
      checkInvitedRecall: true,
      showEditButton: false,
      editflag: false,
      mtlClass:'',

      something: "",
      style: {
        leftStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 325 + "px",
          overflow: "auto",
        },
        rightStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 205 + "px",
        },
        gridStyle: {
          height:
            parseInt(document.documentElement["clientHeight"]) - 215 + "px",
        },
      },
      options1: [
        {
          value: "0",
          label: "新建",
        },
        {
          value: "1",
          label: "已邀请",
        },
        {
          value: "2",
          label: "已撤回",
        },
        {
          value: "3",
          label: "已完善",
        },
      ],
      dataRule: {
        venderCode: [
          {
            required: true,
            message: "供应商代码不能为空",
            trigger: "blur",
          },
        ],
        venderName: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        venderAbbreviation: [
          {
            required: true,
            message: "简称不能为空",
            trigger: "blur",
          },
        ],
        venderContacts: [
          {
            required: true,
            message: "联系人不能为空",
            trigger: "blur",
          },
        ],
        venderTel: [
          {
            required: true,
            message: "电话不能为空",
            trigger: "blur",
          },
        ],
        supcompanyCode: [
          {
            required: true,
            message: "子公司不能为空",
            trigger: "blur",
          },
        ],
        venderAdd: [
          {
            required: true,
            message: "地址不能为空",
            trigger: "blur",
          },
        ],
        venderSource: [
          {
            required: true,
            message: "数据来源不能为空",
            trigger: "blur",
          },
        ],
        venderMail: [
          {
            required: true,
            message: "邮箱不能为空",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur"],
          },
        ],
      },
    };
  },

  activated() {
    this.flag = this.$route.params.gpsStatusvalflag;
    if (this.flag === "1") {
      this.checkCreated = true;
      this.checkInvited = false;
      this.checkInvitedRecall = false;
    }
    if (
      this.$route.query &&
      this.$route.query.gpsStatusval &&
      this.$route.query.gpsStatusval.length > 0
    ) {
      this.gpsStatusval = encodeURI(
        JSON.stringify(this.$route.query.gpsStatusval)
      );
    } else {
      this.gpsStatusval = "";
    }
    if (  this.$route.query &&  this.$route.query.action &&this.$route.query.action === 'create') {
      this.createData()
      this.temp = this.$route.query.data
      this.selectFromOA = true
    }
    this.getDataList();
  },

  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (!date) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      this.getSupCompanyList();
      listSupplierInvite({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        supplierCode: this.venderCode,
        supplierName: this.venderName,
        venderSource: this.venderSource,
        gpsStatusval: this.gpsStatusval,
        checkCreated: this.checkCreated,
        checkInvited: this.checkInvited,
        checkInvitedRecall: this.checkInvitedRecall,
        invitedStatus: this.invitedStatus,
        subcompanyId:this.subcompanyId,
      })
        .then((data) => {
          if (data && data.code === "00") {
            this.dataList = data.body.records;
            this.totalPage = data.body.total;
            this.starttime = data.starttime;
            this.endtime = data.endtime;
            this.interfacestarttime = data.endtime;
          } else {
            this.dataList = [];
            this.totalPage = 0;
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.dataListLoading = false;
        });
    },



    //获取子公司列表
    getSupCompanyList(){
      supCompanyList().then(res=>{
        if(res && res.code == '00'){
          this.supCompanyList = res.body;
          console.log("g",this.supCompanyList)

        }
      })
    },


    // 表单提交
    dataFormSubmit() {
      const me = this;
      let params = {
        id: this.venderinviteId || undefined,
        venderName: this.temp.venderName,
        venderAdd: this.temp.venderAdd,
        venderContacts: this.temp.venderContacts,
        venderTel: this.temp.venderTel,
        venderMail: this.temp.venderMail,
        dataSource: this.selectFromOA == true ? "OA" : null,
        isPru: this.temp.isPru,
        isGen: this.temp.isGen,
        supcompanyCode: this.temp.supcompanyCode
      };

      this.$refs["temp"].validate((valid) => {
        if (valid) {
          if (!this.venderinviteId) {
            if(this.mtlData.length===0){
              return this.$message.warning('请选择供应商物料分类')
            }
            this.submitLoading = true;
            createSupplier(params)
              .then((data) => {
                if (data && data.code === "00") {
                  this.supplierId = data.body.id;
                  this.submitLoading = false;
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                    onClose: () => {
                      this.venderInviteid = data.venderInviteid;
                      this.dialogVisible = false;
                      this.getDataList();
                      this.$nextTick(() => {
                        me.$refs.usersInfo.getDataList(
                          this.venderInviteid,
                          true,
                          me.temp.venderSource
                        );
                      });
                    },
                  });

                  // if (this.selectFromOA) {
                  //   if(this.mtlData.length===0){
                  //     return this.$message.warning('请选择供应商物料分类')
                  //   }
                    //将数据保存到物料表
                    let params1 = {
                      supplierId: this.supplierId,
                      materials: this.mtlData,
                    };
                     console.log("保存的参数", params1);
                    saveToMtl(params1).then((data) => {
                      if (data && data.code == "00") {
                        console.log("保存成功");
                      }
                    });
                  // }
                }
                else if (data && data.code === "03") {
                  this.submitLoading = false;
                  this.$confirm(data.msg, '确认信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  }).then(() => {
                    createUse(params).then((dataDetails)=>{
                      if(dataDetails && dataDetails.code === '00'){
                        this.$message({
                          type: 'success',
                          message: '操作成功!'
                        });
                      }else{
                        this.$message.error(dataDetails.msg);
                      }
                    })
                  }).catch(() => {
                  });
                } else {
                  this.submitLoading = false;
                  this.$message.error(data.msg);
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          } else {
            updateSupplier(params)
              .then((data) => {
                if (data && data.code === "00") {
                  this.submitLoading = false;
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                    onClose: () => {
                      this.venderInviteid = data.venderInviteid;
                      this.dialogVisible = false;
                      this.getDataList();
                      this.$nextTick(() => {
                        me.$refs.usersInfo.getDataList(
                          this.venderInviteid,
                          true,
                          me.temp.venderSource
                        );
                      });
                    },
                  });
                } else {
                  this.submitLoading = false;
                  this.$message.error(data.msg);
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        }
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    //多选
    selectionChangeHandle(val) {
      console.log(val);
      this.dataListSelections = val;
    },
    //单选
    radioChange(row) {
      console.log(row);
      this.dataListSelections = row;
    },
    //邀请
    updateByCheckInvited() {
      let ids = this.dataListSelections.map((item) => {
        return item.id;
      });
      this.$confirm(`确定进行邀请操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.invitedLoading = true;
          inviteSupplier(ids)
            .then((data) => {
              if (data && data.code === "00") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.getDataList();
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            })
            .finally(() => {
              this.invitedLoading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //撤回
    updateByRevert() {
      let ids = this.dataListSelections.map((item) => {
        return item.id;
      });
      this.$confirm(`确定进行撤回操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        inviteRecall(ids).then((data) => {
          if (data && data.code === "00") {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.getDataList();
              },
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    // 删除
    deleteHandle(row) {
      if (row.venderStatus == "1") {
        this.$message.info("已邀请状态不能删除！");
      } else {
        //TODO
        //this.$message.error('开发中……')
        // var ids = row ? [row.rowid] : this.dataListSelections.map(item => {
        //     return item.rowid
        // })
        // var venderIds = row ? [row.venderinviteId + ';' + row.venderSource] : this.dataListSelections.map(item => {
        //     return item.venderId + ';' + item.venderSource
        // })
        console.log(row.id);
        this.$confirm(`确定进行删除操作?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          deleteInviteSupplier({
            id: row.id,
          }).then((data) => {
            if (data && data.code === "00") {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.getDataList();
                },
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        });
      }
    },
    //已完成未完成筛选
    handleCheckAllChange() {
      this.pageIndex = 1;
      this.getDataList();
    },
    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row.id
      row.rowid = rowIndex + 1 + this.pageSize * (this.pageIndex - 1);
    },
    //查看
    venderUserDetail(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.editflag = true;
      this.showUsers = true;
      this.showEditButton = false;
      this.venderinviteId = row.venderinviteId;
      this.dialogVisible = true;
      this.$nextTick(() => {
        // this.$refs.usersInfo.getDataList(row.venderId, false, row.venderSource);
        // this.$refs.usersInfo.getDataList(row.venderId,true,row.venderSource)
      });
      getMaterialGroup({'id' : row.id}).then(res => {
        this.mtlClass = res.body.map((data)=>{
          return `${data.materialGroupCode}-${data.materialGroupName}`
        }).join(',')
      })
    },
    //关闭弹框的事件
    closeDialog() {
      this.supplierAdmitInquiryVisible = false;
      this.selectFromOA = false;
      this.displayNames = [];
      this.getDataList();
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //编辑
    updateHandle(row) {
      if (row.venderStatus == "1") {
        this.$message.info("已邀请状态不能修改！");
      } else {
        this.temp = Object.assign({}, row); // copy obj
        this.editflag = true;
        this.showUsers = true;
        this.showEditButton = true;
        this.venderinviteId = row.id;
        this.dialogVisible = true;
        this.$nextTick(() => {
          // this.$refs.usersInfo.getDataList(row.venderId, true, row.venderSource);
        });
        console.log(this.venderinviteId);
      }
    },
    // 新增
    createData() {
      this.resetTemp();
      this.dialogVisible = true;
      this.editflag = false;
      this.showUsers = true;
      this.venderinviteId = "";
      this.showEditButton = true;
      this.temp.venderSource = "1";
      this.$nextTick(() => {
        // this.$refs['dataForm'].clearValidate()
      });
    },
    resetTemp() {
      this.temp = {
        hanghao: undefined,
        venderName: "",
        venderCode: "",
        venderAbbreviation: "",
        venderAdd: "",
        venderContacts: "",
        venderMail: "",
        venderMailBak: "",
        venderCareerBody: "",
        venderTel: "",
        type: "",
        venderSource: "",
      };
    },
    selectAdmitSupplier() {
      this.supplierAdmitInquiryVisible = true;
      this.$nextTick(() => {
        this.$refs.supplierAdmit.init();
      });
    },

    handleReceivedRowData(row) {
      console.log("从后台接收到的数据", row);
      //将数据填充到表单中
      this.temp = {
        venderName: row.venderName,
        venderAdd: row.venderAdd,
        venderContacts: row.venderContacts,
        venderTel: row.venderTel,
        venderMail: row.venderMail,
        supcompanyCode: row.supcompanyCode,
        // isPruChecked: (row.isPru = "1" ? true : false),
        isPru: row.isPru,
        isGen: row.isGen
      };
      this.selectFromOA = true;
    },
    //打开供应商弹窗
    selectMtlClass() {
      this.supplierMtlVisible = true;
      this.$nextTick(() => {
        this.$refs.supplierMtl.init();
      });
    },
    //获取物料分类数据
    getMaterialGroupNames(newArray) {
      this.mtlData = newArray;
      this.displayNames = newArray;
    },
  },
};
</script>

<style lang="scss">
.fr {
  float: right;
}

.button-danger {
  color: #f56c6c;
}
.non-bullet {
  list-style-type: none;
  padding-left: 0;
}
</style>
